
export const FormatPhoneNumber = ( value: string ) => {

    const digits = value.replace(/\D/g, '').slice( 0, 10 );

    if ( digits.length === 0 ) return '';

    if ( digits.length <= 3 ) {
        return `(${ digits }`;
    }

    if ( digits.length <= 6 ) {
        return `(${ digits.slice(0, 3) }) ${ digits.slice(3) }`;
    }

    return `(${ digits.slice(0, 3) }) ${ digits.slice(3, 6) }-${ digits.slice(6) }`;
}

export const FormatInternationalPhone = ( value: string ) => {

    const clean = value.replace(/[^\d+]/g, "");

    if (!clean.startsWith("+")) return value;

    let countryCode = "";
    let number = "";

    if (clean.startsWith("+52")) {
        countryCode = "+52";
        number = clean.slice(3); 
    } 
    else if (clean.startsWith("+1")) {
        countryCode = "+1";
        number = clean.slice(2);
    } 
    else {
        return value;
    }

    if ( number.length !== 10 ) return value;

    const area = number.slice(0, 3);
    const part1 = number.slice(3, 6);
    const part2 = number.slice(6, 10);

    return `${countryCode} (${area}) ${part1}-${part2}`;
};

export const ClearFormatPhoneNumber = ( value: string ) => value.replace(/\D/g, "").slice( 0, 10 )